{
  "zh-CN": {
    "cart": {
      "title": "购物车",
      "lead": "收集你想在游戏中购买的物品，并查看在哪里能买到。每件物品默认分配到售价最低的地点，你也可以另选。",
      "addToCart": "加入购物车",
      "addLoadout": "将非原厂部件加入购物车",
      "clear": "清空购物车",
      "confirmClear": "要清空购物车中的所有物品吗？",
      "remove": "移除",
      "quantity": "数量",
      "unitPrice": "每件 %{price}",
      "buyElsewhere": "在别处购买",
      "cheapest": "最便宜",
      "planPick": "由计划选择",
      "pinned": "你的选择",
      "tripPick": "路线优先",
      "unplaced": "未知地点",
      "totals": {
        "total": "总计",
        "items": "物品",
        "stops": "停靠点",
        "unavailable": "无处出售"
      },
      "unavailable": {
        "title": "无处出售",
        "text": "据我们所知，目前没有人出售这些物品，因此未计入总计。"
      },
      "empty": {
        "title": "购物车是空的",
        "text": "从目录中添加商品、组件或装备，规划在哪里购买。"
      },
      "messages": {
        "added": "已将 %{name} 加入 %{list}。",
        "addFailed": "无法将物品加入购物车。",
        "updateFailed": "无法更新购物车。",
        "accountRequired": "登录后即可使用购物车。",
        "loadoutAdded": {
          "one": "已将 %{count} 个部件加入 %{list}。",
          "other": "已将 %{count} 个部件加入 %{list}。"
        }
      },
      "lists": {
        "shown": "清单",
        "create": "新建清单",
        "rename": "重命名清单",
        "delete": "删除清单",
        "name": "名称",
        "activate": "设为当前清单",
        "isActive": "当前清单",
        "confirmDelete": "删除清单 %{name} 及其中的所有物品？",
        "messages": {
          "saveFailed": "无法保存清单。"
        }
      },
      "widget": {
        "expand": "显示购物车",
        "collapse": "隐藏购物车",
        "open": "打开购物车",
        "unavailable": "无处出售",
        "more": {
          "one": "还有 %{count} 件",
          "other": "还有 %{count} 件"
        }
      },
      "strategies": {
        "cheapest": {
          "label": "最便宜",
          "hint": "每件物品都在售价最低的地点购买"
        },
        "stops": {
          "label": "最少停靠",
          "hint": "在尽可能少的地点买齐所有物品，必要时多付一点以省去一次停靠"
        },
        "distance": {
          "label": "最短路线",
          "hint": "尽量让停靠点位于相同的行星和星系，必要时多付一点以减少航行"
        }
      },
      "pick": {
        "title": "将 %{name} 加入清单",
        "hint": {
          "one": "%{count} 件",
          "other": "%{count} 件"
        },
        "activeHint": {
          "one": "当前清单 · %{count} 件",
          "other": "当前清单 · %{count} 件"
        },
        "loadoutParts": "非原厂部件",
        "question": "加入："
      },
      "fleetLists": {
        "title": "购物清单",
        "lead": "舰队希望成员配备的装备：制服、护甲、标准配装。将清单复制到你的购物车，查看花费以及购买地点。",
        "count": {
          "one": "%{count} 件物品",
          "other": "%{count} 件物品"
        },
        "copy": "复制到我的购物车",
        "copyTitle": "将 %{name} 复制到",
        "copyNew": "新清单",
        "copyNewHint": "命名为 %{name}，并设为当前清单",
        "copyIntoHint": {
          "one": "包含 %{count} 件物品；数量将累加",
          "other": "包含 %{count} 件物品；数量将累加"
        },
        "showItems": "显示物品",
        "hideItems": "隐藏物品",
        "edit": "编辑",
        "delete": "删除",
        "publish": "发布清单",
        "publishTitle": "发布你的一个清单",
        "editTitle": "编辑购物清单",
        "source": "你的清单",
        "sourceHint": "会将其物品和数量复制到舰队，但不包括所选商店。",
        "replaceFrom": "将物品替换为",
        "replaceHint": "留空则保持物品不变。",
        "description": "描述",
        "confirmDelete": "删除购物清单 %{name}？",
        "empty": {
          "title": "暂无购物清单",
          "text": "军官在此从自己的购物车发布清单，供成员复制到自己的购物车中。"
        },
        "messages": {
          "copied": "已将 %{name} 复制到 %{list}。",
          "copyFailed": "无法将清单复制到你的购物车。",
          "published": "已发布 %{name}。",
          "updated": "已更新 %{name}。",
          "saveFailed": "无法保存购物清单。",
          "deleted": "已删除购物清单。",
          "deleteFailed": "无法删除购物清单。"
        }
      }
    }
  }
}
